module.exports = __webpack_public_path__ + "img/filter-type-fullbody--active.374d6d0d.svg";